<script setup lang="ts">
/** Put in order, stored in the CORRECT order (decision 8): the list as written is the answer key. */
import type { InputPrimaryEvent } from '@shared/ui/fields'
import type { MathExerciseEditorProps } from '../../../../../model/assignments/math-exercise-editors.hook'

import { AppText } from '@shared/ui/typography'
import { InputPrimary } from '@shared/ui/fields'

import { MATH_ORDER_MIN_ITEMS } from '../../../../../lib/assignments/math-practice-schema'
import ExerciseItemList from '../ExerciseItemList.vue'

defineOptions({
  name: 'ExerciseOrder',
})

defineProps<MathExerciseEditorProps>()
</script>

<template>
  <div class="exercise-order">
    <AppText
      name="body2"
      color="slate-500"
    >
      List the items in the correct order. The kid sees them shuffled.
    </AppText>
    <ExerciseItemList
      :exercise="exercise"
      list="items"
      noun="item"
      label="Items, in the correct order"
      :min="MATH_ORDER_MIN_ITEMS"
    >
      <template #item="{ row, update }">
        <InputPrimary
          name="item-text"
          class-name="exercise-order__text"
          :value="row.values.text"
          placeholder="An item — $…$ for math"
          @input="(event: InputPrimaryEvent) => update({ text: String(event.value) })"
        />
      </template>
    </ExerciseItemList>
  </div>
</template>

<style scoped lang="scss" src="./ExerciseOrder.scss" />
